import PanelHeader from './component';

export default PanelHeader;
